// src/store/cursorStore.js
import { create } from "zustand";
import gsap from "gsap";

const useCursorStore = create((set, get) => ({
  cursorElement: null,
  isInteractive: true, // 👈 pour l'anim conditionnelle
  cursorTheme: "light", // "dark" ou "light"

  setCursorElement: (el) => set({ cursorElement: el }),

  setCursorScale: (scale) => {
    const el = get().cursorElement;
    if (el && get().isInteractive) {
      gsap.to(el, { scale, duration: 0.3, ease: "power3.out" });
    }
  },

  setCursorTheme: (theme) => {
    const el = get().cursorElement;
    if (el) {
      el.classList.remove("cursor-light", "cursor-dark");
      el.classList.add(`cursor-${theme}`);
    }
    set({ cursorTheme: theme });
  },

  setCursorInteractive: (val) => set({ isInteractive: val }),
}));


export default useCursorStore;
